// extracted by mini-css-extract-plugin
module.exports = {"fab-container":"FloatingQuestionButton_fab-container__WH913","link":"FloatingQuestionButton_link__AVeg9","strong":"FloatingQuestionButton_strong__mIGzU"};